class Reg {
  // 手机号的表单验证
  validatePhone = (rule, value, callback) => {
    const reg = new RegExp(/^[1]([3-9])[0-9]{9}$/)
    reg.test(value) ? callback() : callback(new Error('手机号输入错误'))
  }

  // 密码验证,必须数字和字母，特殊符号可有可无
  validatePassword = (rule, value, callback) => {
    const reg = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\\W]{6,18}$')
    reg.test(value) ? callback() : callback(new Error('请输入6-18位由数字和字母组合的密码'))
  }

  // 反馈邮箱,手机,qq
  validateFeedBack = (rule, value, callback) => {
    const regPhone = new RegExp(/^[1]([3-9])[0-9]{9}$/)
    const regEmail = new RegExp(/^\w+@[a-z0-9]+\.[a-z]{2,4}$/)
    const regQQ = new RegExp('[1-9]([0-9]{5,13})')
    const flag = regPhone.test(value) || regEmail.test(value) || regQQ.test(value) || value === ''
    flag ? callback() : callback(new Error('请填写正确的手机/邮箱/qq'))
  }
}
export default new Reg()
